/** All locales that are configured in the payload config for this project. */
export type Locale = string
